import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';


class RetweetChart extends Component {

  // componentDidMount = () => {
  //   console.log(
  //     this.refs.retweet_chart_ref.chart_instance
  //   );
  // };

  render() {

    let {
      new_retweets,
      dates
    }
      = this.props;

    let sum_new_retweets = new_retweets.reduce((t, i) => t += i, 0);
    let count_new_retweets = new_retweets.size;

    let ary_new_retweets = new_retweets.toArray();
    let ary_dates = dates.toArray();

    return (
      <Bar
        ref='retweet_chart_ref'
        // height={200}
        data={{
          datasets: [
            {
              label: 'retweets',
              data: ary_new_retweets,
              backgroundColor: 'black',
              hoverBackgroundColor: 'deepskyblue'
            }
          ],
          labels: ary_dates
        }}
        options={{
          animation: {
            duration: 0
          },
          resize: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          title: {
            display: true,
            fontColor: 'deepskyblue',
            fontSize: 16,
            text: `${sum_new_retweets.toLocaleString()} retweets / ` +
            `${count_new_retweets} hours`
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: ((tooltipItem, data) => {
                return tooltipItem.yLabel.toLocaleString();
              })
            }
          },
          scales: {
            xAxes: {
              0: {
                // maxBarThickness: 20,
                gridLines: {
                  display: false,
                  drawBorder: false
                },
                ticks: {
                  autoSkip: true,
                  display: false,
                  fontSize: 11,
                  fontColor: 'blueviolet',
                  callback: ((value, index, values) => {
                    if ((index === 0) || (index === (count_new_retweets - 1))) {
                      return value;
                    }
                  })
                }
              }
            },
            yAxes: {
              0: {
                display: false,
              }
            }
          }
        }}
      />
    );
  }
}


export default RetweetChart;


// WEBPACK FOOTER //
// ./src/containers/engage/charts/RetweetChart.js